import { NgModule, inject } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { throwIfAlreadyLoaded } from './module-import.guard';
import { NavGuard } from './nav-guard/nav.guard';
import { EyefinityGuard } from './eyefinity-guard/eyefinity.guard';
import { AuthenticationGuard } from './authentication-guard/authentication.guard';
import { AuthenticationInterceptor } from './authentication-interceptor/authentication.interceptor';
import { StatusGuard } from './status.guard';

@NgModule({
  imports: [BrowserModule],
  providers: [
    NavGuard,
    EyefinityGuard,
    AuthenticationGuard,
    AuthenticationInterceptor,
    StatusGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    throwIfAlreadyLoaded(parentModule, 'Core Module');
  }
}
